const scrollToTopButton = document.getElementById('scrollToTop');

window.addEventListener('scroll', function () {
  // document.body is null while the document is being replaced
  const showToTopButton =
    document.body?.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight;

  scrollToTopButton?.classList.toggle('show', showToTopButton);
});

scrollToTopButton?.addEventListener('click', function () {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});
